import {connect} from "react-redux";
import Save from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {
    ucdById,
    ucdSave,
    newBankDetailsRequest,
    ucdAgreementNotificationRequest, checkAgreementVerifiedRequest
} from "../../../../service/Dealer/action";
import {locationPinCode, locationCity, locationZone, locationArea, stateAndRegion} from "../../../../service/locations/action";
import {getLeadById} from "../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    ucdDetails:state.Dealer.ucdDetails,
    ucsSaveResponse:state.Dealer.ucsSaveResponse,
    pincodeData: state.locationReducer.pincodeData,
    cities: state.locationReducer.cities,
    zones: state.locationReducer.zones,
    areas: state.locationReducer.areas,
    leadById:state.Lead.leadById,
    newBankDetailsResponse: state.Dealer.newBankDetailsResponse,
    ucdAgreementNotificationResponse: state.Dealer.ucdAgreementNotificationResponse,
    checkAgreementVerifiedResponse: state.Dealer.checkAgreementVerifiedResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            ucdById,
            locationPinCode,
            ucdSave,
            locationCity,
            locationZone,
            locationArea,
            getLeadById,
            newBankDetailsRequest,
            ucdAgreementNotificationRequest,
            checkAgreementVerifiedRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Save);
